// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + {"1564":"78bd5cf5","2265":"canvg","3076":"0b7f46bf","4297":"xlsx","4346":"5493da1b","9943":"948d068f"}[chunkId] + "." + {"1564":"17ece2021d1f278d","2265":"79df7f1d345b30a5","3076":"619f8035f2e9a030","4297":"012bc8c2aa3350c7","4346":"82448bae5bb93889","9943":"badebad7219b5be0"}[chunkId] + ".js";
};